const darkTheme = {
    label:"Dark",
    background: 'black',
    title: 'pink',
    typeBoxText: 'grey',
    stats: 'green'
}


const redTheme = {
    label: 'Red Theme',
    background: '#fec8cd',
    title: "white",
    typeBoxText: 'blue',
    stats: 'purple'
}

const  luna = {
    label: 'Luna',
    background: '#221C35',
    title: '#F67599',
    typeBoxText: '#5A3A7E',
    stats: '#F67599'
}
const afterdark={
    label:'80s After dark',
    background:'#1b1d36',
    title:'#fca6d1',
    typeBoxText:'#99d6ea',
    stats:"#fca6d1"    
}
const aether={
    label:'Aether',
    background:'#101820',
    title:'#cf6bdd',  
    typeBoxText:'#cf6bdd',
    stats: '#eedaea'     
}
const bliss={
    label:'Bliss',
    background:'#262727',
    title:'#f0d3c9',
    typeBoxText:'#fff',
    stats:'#f0d3c9'
}
const dino={
    label:'Dino',
    background:'white',
    title:'#40d672',
    typeBoxText:'green',
    stats:'#40d672'
}

export const themeOptions = [
    {value: darkTheme, label: 'Dark'},
    {value: redTheme, label: 'Red Theme'},
    {value: luna, label:'Luna'},
    {value:afterdark,label:'80s after dark'},
    {value:aether,label:'aether'},
    {value:bliss,label:'Bliss'},
    {value:dino,label:'Dino'}    
];